import { render, staticRenderFns } from "./TeamSettingsIcon.vue?vue&type=template&id=d718af34&scoped=true"
import script from "./TeamSettingsIcon.vue?vue&type=script&lang=js"
export * from "./TeamSettingsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d718af34",
  null
  
)

export default component.exports